// Countries no longer allowed to receive supplies due to sanctions (see https://www.paddle.com/help/legal/sanctions/which-countries-are-supported-by-paddle)
var EPaddleCountryKeySanctioned = /*#__PURE__*/ function(EPaddleCountryKeySanctioned) {
    EPaddleCountryKeySanctioned["Afghanistan"] = "AF";
    EPaddleCountryKeySanctioned["Belarus"] = "BY";
    EPaddleCountryKeySanctioned["CentralAfricanRepublic"] = "CF";
    EPaddleCountryKeySanctioned["Congo"] = "CG";
    EPaddleCountryKeySanctioned["Cuba"] = "CU";
    EPaddleCountryKeySanctioned["Haiti"] = "HT";
    EPaddleCountryKeySanctioned["Iran"] = "IR";
    EPaddleCountryKeySanctioned["Mali"] = "ML";
    EPaddleCountryKeySanctioned["Myanmar"] = "MM";
    EPaddleCountryKeySanctioned["NorthKorea"] = "KP";
    EPaddleCountryKeySanctioned["RussianFederation"] = "RU";
    EPaddleCountryKeySanctioned["Sudan"] = "SD";
    EPaddleCountryKeySanctioned["SyrianArabRepublic"] = "SY";
    EPaddleCountryKeySanctioned["Venezuela"] = "VE";
    EPaddleCountryKeySanctioned["Yemen"] = "YE";
    EPaddleCountryKeySanctioned["Zimbabwe"] = "ZW";
    return EPaddleCountryKeySanctioned;
}(EPaddleCountryKeySanctioned || {});
var EPaddleCountryKey = /*#__PURE__*/ function(EPaddleCountryKey) {
    EPaddleCountryKey["Afghanistan"] = "AF";
    EPaddleCountryKey["AlandIslands"] = "AX";
    EPaddleCountryKey["Albania"] = "AL";
    EPaddleCountryKey["Algeria"] = "DZ";
    EPaddleCountryKey["AmericanSamoa"] = "AS";
    EPaddleCountryKey["Andorra"] = "AD";
    EPaddleCountryKey["Angola"] = "AO";
    EPaddleCountryKey["Anguilla"] = "AI";
    EPaddleCountryKey["AntiguaandBarbuda"] = "AG";
    EPaddleCountryKey["Argentina"] = "AR";
    EPaddleCountryKey["Armenia"] = "AM";
    EPaddleCountryKey["Aruba"] = "AW";
    EPaddleCountryKey["Australia"] = "AU";
    EPaddleCountryKey["Austria"] = "AT";
    EPaddleCountryKey["Azerbaijan"] = "AZ";
    EPaddleCountryKey["Bahamas"] = "BS";
    EPaddleCountryKey["Bahrain"] = "BH";
    EPaddleCountryKey["Bangladesh"] = "BD";
    EPaddleCountryKey["Barbados"] = "BB";
    EPaddleCountryKey["Belarus"] = "BY";
    EPaddleCountryKey["Belgium"] = "BE";
    EPaddleCountryKey["Belize"] = "BZ";
    EPaddleCountryKey["Benin"] = "BJ";
    EPaddleCountryKey["Bermuda"] = "BM";
    EPaddleCountryKey["Bhutan"] = "BT";
    EPaddleCountryKey["Bolivia"] = "BO";
    EPaddleCountryKey["BonaireSintEustatiusandSaba"] = "BQ";
    EPaddleCountryKey["BosniaandHerzegovina"] = "BA";
    EPaddleCountryKey["Botswana"] = "BW";
    EPaddleCountryKey["BouvetIsland"] = "BV";
    EPaddleCountryKey["Brazil"] = "BR";
    EPaddleCountryKey["BritIndianOcean"] = "IO";
    EPaddleCountryKey["BritishVirginIslands"] = "VG";
    EPaddleCountryKey["BruneiDarussalam"] = "BN";
    EPaddleCountryKey["Bulgaria"] = "BG";
    EPaddleCountryKey["BurkinaFaso"] = "BF";
    EPaddleCountryKey["Burundi"] = "BI";
    EPaddleCountryKey["Cambodia"] = "KH";
    EPaddleCountryKey["Cameroon"] = "CM";
    EPaddleCountryKey["Canada"] = "CA";
    EPaddleCountryKey["CapeVerde"] = "CV";
    EPaddleCountryKey["CaymanIslands"] = "KY";
    EPaddleCountryKey["CentralAfricanRepublic"] = "CF";
    EPaddleCountryKey["Chad"] = "TD";
    EPaddleCountryKey["Chile"] = "CL";
    EPaddleCountryKey["China"] = "CN";
    EPaddleCountryKey["ChristmasIsland"] = "CX";
    EPaddleCountryKey["CocosIslands"] = "CC";
    EPaddleCountryKey["Colombia"] = "CO";
    EPaddleCountryKey["Comoros"] = "KM";
    EPaddleCountryKey["Congo"] = "CG";
    EPaddleCountryKey["CookIslands"] = "CK";
    EPaddleCountryKey["CostaRica"] = "CR";
    EPaddleCountryKey["CoteDIvoire"] = "CI";
    EPaddleCountryKey["Croatia"] = "HR";
    EPaddleCountryKey["Cuba"] = "CU";
    EPaddleCountryKey["Cura\xe7ao"] = "CW";
    EPaddleCountryKey["Cyprus"] = "CY";
    EPaddleCountryKey["CzechRepublic"] = "CZ";
    EPaddleCountryKey["Denmark"] = "DK";
    EPaddleCountryKey["Djibouti"] = "DJ";
    EPaddleCountryKey["Dominica"] = "DM";
    EPaddleCountryKey["DominicanRepublic"] = "DO";
    EPaddleCountryKey["Ecuador"] = "EC";
    EPaddleCountryKey["Egypt"] = "EG";
    EPaddleCountryKey["ElSalvador"] = "SV";
    EPaddleCountryKey["EquatorialGuinea"] = "GQ";
    EPaddleCountryKey["Eritrea"] = "ER";
    EPaddleCountryKey["Estonia"] = "EE";
    EPaddleCountryKey["Ethiopia"] = "ET";
    EPaddleCountryKey["FalklandIslands"] = "FK";
    EPaddleCountryKey["FaroeIslands"] = "FO";
    EPaddleCountryKey["Fiji"] = "FJ";
    EPaddleCountryKey["Finland"] = "FI";
    EPaddleCountryKey["Frankreich"] = "FR";
    EPaddleCountryKey["FrenchGuiana"] = "GF";
    EPaddleCountryKey["FrenchPolynesia"] = "PF";
    EPaddleCountryKey["FrenchSouthernTerr"] = "TF";
    EPaddleCountryKey["Gabon"] = "GA";
    EPaddleCountryKey["Gambia"] = "GM";
    EPaddleCountryKey["Georgia"] = "GE";
    EPaddleCountryKey["Germany"] = "DE";
    EPaddleCountryKey["Ghana"] = "GH";
    EPaddleCountryKey["Gibraltar"] = "GI";
    EPaddleCountryKey["Greece"] = "GR";
    EPaddleCountryKey["Greenland"] = "GL";
    EPaddleCountryKey["Grenada"] = "GD";
    EPaddleCountryKey["Guadeloupe"] = "GP";
    EPaddleCountryKey["Guam"] = "GU";
    EPaddleCountryKey["Guatemala"] = "GT";
    EPaddleCountryKey["Guernsey"] = "GG";
    EPaddleCountryKey["Guinea"] = "GN";
    EPaddleCountryKey["GuineaBissau"] = "GW";
    EPaddleCountryKey["Guyana"] = "GY";
    EPaddleCountryKey["Haiti"] = "HT";
    EPaddleCountryKey["HeardMcdonaldIslands"] = "HM";
    EPaddleCountryKey["HolySeeVaticanCity"] = "VA";
    EPaddleCountryKey["Honduras"] = "HN";
    EPaddleCountryKey["HongKong"] = "HK";
    EPaddleCountryKey["Hungary"] = "HU";
    EPaddleCountryKey["Iceland"] = "IS";
    EPaddleCountryKey["India"] = "IN";
    EPaddleCountryKey["Indonesia"] = "ID";
    EPaddleCountryKey["Iran"] = "IR";
    EPaddleCountryKey["Iraq"] = "IQ";
    EPaddleCountryKey["Ireland"] = "IE";
    EPaddleCountryKey["IsleofMan"] = "IM";
    EPaddleCountryKey["Israel"] = "IL";
    EPaddleCountryKey["Italy"] = "IT";
    EPaddleCountryKey["Jamaica"] = "JM";
    EPaddleCountryKey["Japan"] = "JP";
    EPaddleCountryKey["Jersey"] = "JE";
    EPaddleCountryKey["Jordan"] = "JO";
    EPaddleCountryKey["Kazakhstan"] = "KZ";
    EPaddleCountryKey["Kenya"] = "KE";
    EPaddleCountryKey["Kiribati"] = "KI";
    EPaddleCountryKey["Kuwait"] = "KW";
    EPaddleCountryKey["Kyrgyzstan"] = "KG";
    EPaddleCountryKey["LaoPeoplesDR"] = "LA";
    EPaddleCountryKey["Latvia"] = "LV";
    EPaddleCountryKey["Lebanon"] = "LB";
    EPaddleCountryKey["Lesotho"] = "LS";
    EPaddleCountryKey["Liberia"] = "LR";
    EPaddleCountryKey["LibyanArabJamahiriya"] = "LY";
    EPaddleCountryKey["Liechtenstein"] = "LI";
    EPaddleCountryKey["Lithuania"] = "LT";
    EPaddleCountryKey["Luxembourg"] = "LU";
    EPaddleCountryKey["Macao"] = "MO";
    EPaddleCountryKey["Macedonia"] = "MK";
    EPaddleCountryKey["Madagascar"] = "MG";
    EPaddleCountryKey["Malawi"] = "MW";
    EPaddleCountryKey["Malaysia"] = "MY";
    EPaddleCountryKey["Maldives"] = "MV";
    EPaddleCountryKey["Mali"] = "ML";
    EPaddleCountryKey["Malta"] = "MT";
    EPaddleCountryKey["MarshallIslands"] = "MH";
    EPaddleCountryKey["Martinique"] = "MQ";
    EPaddleCountryKey["Mauritania"] = "MR";
    EPaddleCountryKey["Mauritius"] = "MU";
    EPaddleCountryKey["Mayotte"] = "YT";
    EPaddleCountryKey["Mexico"] = "MX";
    EPaddleCountryKey["Micronesia"] = "FM";
    EPaddleCountryKey["Moldova"] = "MD";
    EPaddleCountryKey["Monaco"] = "MC";
    EPaddleCountryKey["Mongolia"] = "MN";
    EPaddleCountryKey["Montenegro"] = "ME";
    EPaddleCountryKey["Montserrat"] = "MS";
    EPaddleCountryKey["Morocco"] = "MA";
    EPaddleCountryKey["Mozambique"] = "MZ";
    EPaddleCountryKey["Myanmar"] = "MM";
    EPaddleCountryKey["Namibia"] = "NA";
    EPaddleCountryKey["Nauru"] = "NR";
    EPaddleCountryKey["Nepal"] = "NP";
    EPaddleCountryKey["Netherlands"] = "NL";
    EPaddleCountryKey["NetherlandsAntilles"] = "AN";
    EPaddleCountryKey["NewCaledonia"] = "NC";
    EPaddleCountryKey["NewZealand"] = "NZ";
    EPaddleCountryKey["Nicaragua"] = "NI";
    EPaddleCountryKey["Niger"] = "NE";
    EPaddleCountryKey["Nigeria"] = "NG";
    EPaddleCountryKey["Niue"] = "NU";
    EPaddleCountryKey["NorfolkIsland"] = "NF";
    EPaddleCountryKey["NorthKorea"] = "KP";
    EPaddleCountryKey["NorthernMarianaIslands"] = "MP";
    EPaddleCountryKey["Norway"] = "NO";
    EPaddleCountryKey["Oman"] = "OM";
    EPaddleCountryKey["Pakistan"] = "PK";
    EPaddleCountryKey["Palau"] = "PW";
    EPaddleCountryKey["PalestinianTerritory"] = "PS";
    EPaddleCountryKey["Panama"] = "PA";
    EPaddleCountryKey["PapuaNewGuinea"] = "PG";
    EPaddleCountryKey["Paraguay"] = "PY";
    EPaddleCountryKey["Peru"] = "PE";
    EPaddleCountryKey["Philippines"] = "PH";
    EPaddleCountryKey["Pitcairn"] = "PN";
    EPaddleCountryKey["Poland"] = "PL";
    EPaddleCountryKey["Portugal"] = "PT";
    EPaddleCountryKey["PuertoRico"] = "PR";
    EPaddleCountryKey["Qatar"] = "QA";
    EPaddleCountryKey["RepublicofSerbia"] = "RS";
    EPaddleCountryKey["Reunion"] = "RE";
    EPaddleCountryKey["Romania"] = "RO";
    EPaddleCountryKey["RussianFederation"] = "RU";
    EPaddleCountryKey["Rwanda"] = "RW";
    EPaddleCountryKey["SGeorgiaSandwichIslands"] = "GS";
    EPaddleCountryKey["SaintHelena"] = "SH";
    EPaddleCountryKey["SaintKittsandNevis"] = "KN";
    EPaddleCountryKey["SaintLucia"] = "LC";
    EPaddleCountryKey["SaintMartin"] = "MF";
    EPaddleCountryKey["SaintPierreandMiquelon"] = "PM";
    EPaddleCountryKey["SaintVincentGrenadines"] = "VC";
    EPaddleCountryKey["Samoa"] = "WS";
    EPaddleCountryKey["SanMarino"] = "SM";
    EPaddleCountryKey["SaoTomeandPrincipe"] = "ST";
    EPaddleCountryKey["SaudiArabia"] = "SA";
    EPaddleCountryKey["Senegal"] = "SN";
    EPaddleCountryKey["Seychelles"] = "SC";
    EPaddleCountryKey["SierraLeone"] = "SL";
    EPaddleCountryKey["Singapore"] = "SG";
    EPaddleCountryKey["Slovakia"] = "SK";
    EPaddleCountryKey["Slovenia"] = "SI";
    EPaddleCountryKey["SolomonIslands"] = "SB";
    EPaddleCountryKey["Somalia"] = "SO";
    EPaddleCountryKey["SouthAfrica"] = "ZA";
    EPaddleCountryKey["SouthKorea"] = "KR";
    EPaddleCountryKey["Spain"] = "ES";
    EPaddleCountryKey["SriLanka"] = "LK";
    EPaddleCountryKey["Sudan"] = "SD";
    EPaddleCountryKey["Suriname"] = "SR";
    EPaddleCountryKey["SvalbardandJanMayen"] = "SJ";
    EPaddleCountryKey["Swaziland"] = "SZ";
    EPaddleCountryKey["Sweden"] = "SE";
    EPaddleCountryKey["Switzerland"] = "CH";
    EPaddleCountryKey["SyrianArabRepublic"] = "SY";
    EPaddleCountryKey["Taiwan"] = "TW";
    EPaddleCountryKey["Tajikistan"] = "TJ";
    EPaddleCountryKey["Tanzania"] = "TZ";
    EPaddleCountryKey["Thailand"] = "TH";
    EPaddleCountryKey["TimorLeste"] = "TL";
    EPaddleCountryKey["Togo"] = "TG";
    EPaddleCountryKey["Tokelau"] = "TK";
    EPaddleCountryKey["Tonga"] = "TO";
    EPaddleCountryKey["TrinidadandTobago"] = "TT";
    EPaddleCountryKey["Tunisia"] = "TN";
    EPaddleCountryKey["Turkey"] = "TR";
    EPaddleCountryKey["Turkmenistan"] = "TM";
    EPaddleCountryKey["TurksandCaicosIslands"] = "TC";
    EPaddleCountryKey["Tuvalu"] = "TV";
    EPaddleCountryKey["USVirginIslands"] = "VI";
    EPaddleCountryKey["Uganda"] = "UG";
    EPaddleCountryKey["Ukraine"] = "UA";
    EPaddleCountryKey["UnitedArabEmirates"] = "AE";
    EPaddleCountryKey["UnitedKingdom"] = "GB";
    EPaddleCountryKey["UnitedStates"] = "US";
    EPaddleCountryKey["UnitedStatesMOI"] = "UM";
    EPaddleCountryKey["Uruguay"] = "UY";
    EPaddleCountryKey["Uzbekistan"] = "UZ";
    EPaddleCountryKey["Vanuatu"] = "VU";
    EPaddleCountryKey["Venezuela"] = "VE";
    EPaddleCountryKey["VietNam"] = "VN";
    EPaddleCountryKey["WallisandFutuna"] = "WF";
    EPaddleCountryKey["WesternSahara"] = "EH";
    EPaddleCountryKey["Yemen"] = "YE";
    EPaddleCountryKey["Zambia"] = "ZM";
    EPaddleCountryKey["Zimbabwe"] = "ZW";
    return EPaddleCountryKey;
}(EPaddleCountryKey || {});
export { EPaddleCountryKey, EPaddleCountryKeySanctioned };
